import { getDateTranslation } from './locale/cs'

function isNumberInInterval(value: number, lowest: number, uppest: number): boolean {
  const { isInteger } = Number

  if (!isInteger(value)) {
    return false
  }

  return value >= lowest && value <= uppest
}

function isValidDate(text: string) {
  const [days, months] = text.split('.')

  const daysParsed = parseInt(days)
  const monthsParsed = parseInt(months)

  if (!isNumberInInterval(daysParsed, 1, 31)) {
    return false
  }

  return isNumberInInterval(monthsParsed, 1, 12)
}

function getIndexOfDateFormat(text: string): number {
  const [days, months] = text.split('.')

  if (days.trim().length < 2) {
    return 1
  }

  if (months.trim().length < 2) {
    return 1
  }

  return 0
}

function getReplacement(text: string): string | undefined {
  const index = getIndexOfDateFormat(text)
  const dateTranslation = getDateTranslation().find(date => date?.[index]?.trim() === text?.trim())

  return dateTranslation?.pop()
}

function getTextWithPhoneme(text: string): string {
  const PRONUNCIATION_RULES: { [key: string]: string } = { Jane: 'jane' }

  const regex = new RegExp(
    `(^|[^\\w])(${Object.keys(PRONUNCIATION_RULES).join('|')})($|[^\\w])`,
    'gui'
  )

  return text.replace(regex, (match, prefix, key, postfix) => {
    const phoneme = PRONUNCIATION_RULES[key]
    if (!phoneme) {
      return match
    }

    return `${prefix}<phoneme alphabet="ipa" ph="${phoneme}">${key}</phoneme>${postfix}`
  })
}

function getTextDateWithSubAlias(text: string): string {
  const regex = new RegExp(`<say-as interpret-as="date" format="dm">(.*?)<\/say-as>`, 'gui')

  return text.replace(regex, (match, value) => {
    if (!isValidDate(value)) {
      return match
    }

    const replacement = getReplacement(value)

    if (!replacement) {
      return match
    }

    return `<sub alias="${replacement}">${value}</sub>`
  })
}

export function replacePronunciationRules(text: string): string {
  const textWithSubAlias = getTextDateWithSubAlias(text)

  return getTextWithPhoneme(textWithSubAlias)
}

// TODO unify with linuxboxService.ts
export function formatMessageText(rawText?: string, rate?: string): string {
  const text = replacePronunciationRules(rawText ?? '')

  if (rate && text) {
    return `<prosody rate="${rate}">${text}</prosody>`
  }

  return text
}
